import { Outlet } from 'react-router-dom'
import { Suspense } from 'react'

// Sidebar dinamico de BrainHub Core
import { DynamicSidebar } from '@/core/components'
import { MobileNavigation } from './MobileNavigation'
import { InstallBanner } from './InstallBanner'
import { ChatPanel } from '@/core/components/chat/ChatPanel'
import { AvisoMeetHoy } from '@/components/avisos/AvisoMeetHoy'
import { MOBILE_NAV_PADDING } from '@/core/constants/navigation'
import { esEntornoNoProductivo } from '@/lib/entorno'

function LoadingFallback() {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
    </div>
  )
}

const isNonProd = esEntornoNoProductivo()

export function MainLayout() {
  return (
    // El banner de entorno es `fixed`: sin este padding tapa los primeros 20px del sidebar.
    // Iba solo en el <main>, así que el sidebar quedaba debajo de la franja (ORR-378).
    <div className={`flex h-screen bg-background ${isNonProd ? 'pt-5' : ''}`}>
      {isNonProd && (
        <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-amber-950 text-center text-xs font-semibold py-0.5 tracking-wide">
          ENTORNO DE DESARROLLO
        </div>
      )}
      <DynamicSidebar />
      <main className={`flex-1 overflow-auto ${MOBILE_NAV_PADDING} md:pb-0`}>
        <Suspense fallback={<LoadingFallback />}>
          <Outlet />
        </Suspense>
      </main>
      <ChatPanel />
      <MobileNavigation />
      <InstallBanner />
      <AvisoMeetHoy />
    </div>
  )
}
